module.exports = __webpack_public_path__ + "static/img/doc.f7d13a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/doc.png
// module id = UR5A
// module chunks = 155